import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Sein from '../../assets/images/Group 33797.png';
import Log from '../../assets/images/logout1.png';
import Log1 from '../../assets/images/logout2.png';

const EditableBlockList = ({ onSave }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  
  // État global pour tout le formulaire
  const [labodata, setLabodata] = useState({
    xray: {
      chestRibsAbdomen: {},
      headNeck: {},
      specialExaminations: {
        otherSpecify: ""
      },
      spinePelvis: {},
      upperExtremities: {},
      lowerExtremities: {
        toeSpecify: ""
      },
      notes: ""
    },
    mammogram: {
      options: {},
      lastExamDate: "",
      notes: ""
    },
    digestiveRadiology: {},
    musculoskeletal: {
      ultrasound: {
        regions: {},
        other: ""
      },
      fluoroscopy: {
        regions: {},
        levels: ""
      }
    },
    ultrasound: {
      general: {},
      obstetrical: {}
    },
    doppler: {
      venous: {},
      arterial: {},
      others: {}
    },
    ctScan: {
      head: {
        otherSpecify: ""
      },
      body: {},
      spine: {},
      procedures: {
        foraminalBlock: {
          roots: ""
        },
        angioscan: {},
        otherSpecify: ""
      }
    },
    mri: {
      headNeck: {
        otherSpecify: ""
      },
      body: {},
      spine: {},
      extremities: {},
      angiography: {},
      otherSpecify: ""
    }
  });

  // Gestion des changements
  const handleCheckboxChange = (section, field, id, value) => {
    setLabodata(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: {
          ...prev[section][field],
          [id]: value
        }
      }
    }));
  };

  const handleTextChange = (section, field, subField, value) => {
    setLabodata(prev => {
      const newData = { ...prev };
      if (subField) {
        newData[section][field][subField] = value;
      } else {
        newData[section][field] = value;
      }
      return newData;
    });
  };

  const handleDateChange = (date) => {
    setLabodata(prev => ({
      ...prev,
      mammogram: {
        ...prev.mammogram,
        lastExamDate: date
      }
    }));
  };

  const handleSideCheckbox = (section, field, item, side, value) => {
    const id = `${item.toLowerCase()}-${side.toLowerCase()}`;
    handleCheckboxChange(section, field, id, value);
  };

  const handleSave = () => {
    if (onSave) {
      onSave(labodata);
    }
    setShowModal(false);
  };

  const toggleDropdown = () => setIsOpen(!isOpen);
  const handleOpenModal = () => setShowModal(true);

  return (
    <div>
      <div className="position-relative">
        <p className="py-3 fw-bold ms-5" onClick={toggleDropdown}>
          Laboratory Tests
          <i className="bi bi-caret-down-fill" style={{ color: '#FF9800' }}></i>
        </p>
      </div>

      {isOpen && (
        <div>
          <div className="d-flex flex-column ms-5">
            <Button onClick={handleOpenModal}>Add Test</Button>
          </div>
        </div>
      )}

      <Modal show={showModal} onHide={() => setShowModal(false)} size="xl" scrollable>
        <Modal.Header closeButton>
          <Modal.Title>Laboratory Test Details</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          {/* Section X-RAY */}
          <section>
            <div className="text-white text-center py-3 mb-4" style={{ background: '#0056B3', borderRadius: '15px' }}>
              <h2 className="text-2xl font-bold">X-RAY</h2>
            </div>
            
            {/* CHEST / RIBS / ABDOMEN */}
            <div>
              <h3 className="mb-3" style={{ color: '#0056B3', fontSize: '14px', fontWeight: '800', whiteSpace: 'nowrap' }}>
                CHEST / RIBS / ABDOMEN
              </h3>
              {["Chest", "Thorax", "Sternum", "Abdomen"].map((item) => (
                <div key={item} className="d-flex align-items-center mb-2">
                  <input
                    type="checkbox"
                    checked={labodata.xray.chestRibsAbdomen[item.toLowerCase()] || false}
                    onChange={(e) => handleCheckboxChange(
                      'xray', 
                      'chestRibsAbdomen', 
                      item.toLowerCase(), 
                      e.target.checked
                    )}
                    className="me-2 checkbox"
                  />
                  <label className="me-3 form-check-label" style={{ fontSize: "14px" }}>
                    {item}
                  </label>

                  {item === "Thorax" && (
                    <>
                      <input
                        type="checkbox"
                        checked={labodata.xray.chestRibsAbdomen['thorax-r'] || false}
                        onChange={(e) => handleSideCheckbox(
                          'xray',
                          'chestRibsAbdomen',
                          'thorax',
                          'r',
                          e.target.checked
                        )}
                        className="me-2 checkbox"
                      />
                      <label className="me-3 form-check-label" style={{ fontSize: "14px" }}>R</label>

                      <input
                        type="checkbox"
                        checked={labodata.xray.chestRibsAbdomen['thorax-l'] || false}
                        onChange={(e) => handleSideCheckbox(
                          'xray',
                          'chestRibsAbdomen',
                          'thorax',
                          'l',
                          e.target.checked
                        )}
                        className="me-2 checkbox"
                      />
                      <label className="form-check-label" style={{ fontSize: "14px" }}>L</label>
                    </>
                  )}
                </div>
              ))}
            </div>
            <br />

            {/* HEAD / NECK */}
            <div>
              <h3 className="mb-3" style={{ color: '#0056B3', fontSize: '14px', fontWeight: '800', whiteSpace: 'nowrap' }}>
                HEAD / NECK
              </h3>
              {["Cranium", "Facial bones", "Mandible (lower jaw)", "Neck soft tissue", "Cavum", "Nasal bones", "Orbits", "Mastoid bones", "T.M.J."].map((item) => (
                <div key={item} className="d-flex align-items-center mb-2">
                  <input
                    type="checkbox"
                    checked={labodata.xray.headNeck[item.toLowerCase()] || false}
                    onChange={(e) => handleCheckboxChange(
                      'xray', 
                      'headNeck', 
                      item.toLowerCase(), 
                      e.target.checked
                    )}
                    className="me-2 checkbox"
                  />
                  <label className="me-3 form-check-label" style={{ fontSize: "14px" }}>
                    {item}
                  </label>
                </div>
              ))}
            </div>
            <br />

            {/* SPECIAL EXAMINATIONS */}
            <div>
              <h3 className="mb-3" style={{ color: '#0056B3', fontSize: '14px', fontWeight: '800', whiteSpace: 'nowrap' }}>
                SPECIAL EXAMINATIONS
              </h3>
              {["Arthritic series", "Metastatic series", "Other (specify)"].map((item) => (
                <div key={item} className="d-flex align-items-center mb-2">
                  <input
                    type="checkbox"
                    checked={labodata.xray.specialExaminations[item.toLowerCase()] || false}
                    onChange={(e) => handleCheckboxChange(
                      'xray', 
                      'specialExaminations', 
                      item.toLowerCase(), 
                      e.target.checked
                    )}
                    className="me-2 checkbox"
                  />
                  <label className="me-3 form-check-label" style={{ fontSize: "14px", whiteSpace: 'nowrap' }}>
                    {item}
                  </label>

                  {item === "Other (specify)" && (
                    <input
                      type="text"
                      value={labodata.xray.specialExaminations.otherSpecify}
                      onChange={(e) => handleTextChange(
                        'xray',
                        'specialExaminations',
                        'otherSpecify',
                        e.target.value
                      )}
                      className="me-2 form-control"
                      style={{ border: 'none', width: '20%', borderBottom: '2px solid #0056B3', borderRadius: '0' }}
                    />
                  )}
                </div>
              ))}
            </div>
            <br />

            {/* SPINE / PELVIS */}
            <div>
              <h3 className="mb-3" style={{ color: '#0056B3', fontSize: '14px', fontWeight: '800', whiteSpace: 'nowrap' }}>
                SPINE / PELVIS
              </h3>
              {["Cervical", "Thoracic", "Lumbosacral", "Sacroiliac joints", "Pelvis", "Hip", "Sacrum", "Coccyx", "Scoliosis series"].map((item) => (
                <div key={item} className="d-flex align-items-center mb-2">
                  <input
                    type="checkbox"
                    checked={labodata.xray.spinePelvis[item.toLowerCase()] || false}
                    onChange={(e) => handleCheckboxChange(
                      'xray', 
                      'spinePelvis', 
                      item.toLowerCase(), 
                      e.target.checked
                    )}
                    className="me-2 checkbox"
                  />
                  <label className="me-3 form-check-label" style={{ fontSize: "14px" }}>
                    {item}
                  </label>

                  {item === "Hip" && (
                    <>
                      <input
                        type="checkbox"
                        checked={labodata.xray.spinePelvis['hip-r'] || false}
                        onChange={(e) => handleSideCheckbox(
                          'xray',
                          'spinePelvis',
                          'hip',
                          'r',
                          e.target.checked
                        )}
                        className="me-2 checkbox"
                      />
                      <label className="me-3 form-check-label" style={{ fontSize: "14px" }}>R</label>

                      <input
                        type="checkbox"
                        checked={labodata.xray.spinePelvis['hip-l'] || false}
                        onChange={(e) => handleSideCheckbox(
                          'xray',
                          'spinePelvis',
                          'hip',
                          'l',
                          e.target.checked
                        )}
                        className="me-2 checkbox"
                      />
                      <label className="form-check-label" style={{ fontSize: "14px" }}>L</label>
                    </>
                  )}
                </div>
              ))}
            </div>
            <br />

            {/* UPPER EXTREMITIES */}
            <div>
              <h3 className="mb-3" style={{ color: '#0056B3', fontSize: '14px', fontWeight: '800', whiteSpace: 'nowrap' }}>
                UPPER EXTREMITIES
              </h3>
              {["Acromioclavicular joints", "Sternoclavicular joints", "Bone age", "Clavicle", "Scapula", "Shoulder", "Humerus", "Elbow", "Forearm", "Wrist", "Hand", "Finger"].map((item) => (
                <div key={item} className="d-flex align-items-center mb-2">
                  <div className="d-flex align-items-center">
                    <input
                      type="checkbox"
                      checked={labodata.xray.upperExtremities[item.toLowerCase()] || false}
                      onChange={(e) => handleCheckboxChange(
                        'xray', 
                        'upperExtremities', 
                        item.toLowerCase(), 
                        e.target.checked
                      )}
                      className="me-2 checkbox"
                    />
                    <label className="form-check-label" style={{ fontSize: "14px", width: "80px" }}>
                      {item}
                    </label>
                  </div>

                  {["Clavicle", "Scapula", "Shoulder", "Humerus", "Elbow", "Forearm", "Wrist", "Hand", "Finger"].includes(item) && (
                    <>
                      <div className="d-flex">
                        <input
                          type="checkbox"
                          checked={labodata.xray.upperExtremities[`${item.toLowerCase()}-r`] || false}
                          onChange={(e) => handleSideCheckbox(
                            'xray',
                            'upperExtremities',
                            item,
                            'r',
                            e.target.checked
                          )}
                          className="checkbox"
                        />
                        <label className="form-check-label">R</label>
                      </div>

                      <div className="d-flex ms-2">
                        <input
                          type="checkbox"
                          checked={labodata.xray.upperExtremities[`${item.toLowerCase()}-l`] || false}
                          onChange={(e) => handleSideCheckbox(
                            'xray',
                            'upperExtremities',
                            item,
                            'l',
                            e.target.checked
                          )}
                          className="checkbox"
                        />
                        <label className="form-check-label">L</label>
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
            <br />

            {/* LOWER EXTREMITIES */}
            <div>
              <h3 className="mb-3" style={{ color: '#0056B3', fontSize: '14px', fontWeight: '800', whiteSpace: 'nowrap' }}>
                LOWER EXTREMITIES
              </h3>
              {["Knee", "Femur", "Leg", "Ankle", "Foot", "Orthodiagraphy (lower extremity measurements)", "Toe specify"].map((item) => (
                <div key={item} className="d-flex align-items-center mb-2">
                  <div className="d-flex align-items-center">
                    <input
                      type="checkbox"
                      checked={labodata.xray.lowerExtremities[item.toLowerCase()] || false}
                      onChange={(e) => handleCheckboxChange(
                        'xray', 
                        'lowerExtremities', 
                        item.toLowerCase(), 
                        e.target.checked
                      )}
                      className="me-2 checkbox"
                    />
                    <label className="form-check-label" style={{ fontSize: "14px", width: "80px" }}>
                      {item}
                    </label>
                  </div>

                  {["Knee", "Femur", "Leg", "Ankle", "Foot"].includes(item) && (
                    <>
                      <div className="d-flex">
                        <input
                          type="checkbox"
                          checked={labodata.xray.lowerExtremities[`${item.toLowerCase()}-r`] || false}
                          onChange={(e) => handleSideCheckbox(
                            'xray',
                            'lowerExtremities',
                            item,
                            'r',
                            e.target.checked
                          )}
                          className="checkbox"
                        />
                        <label className="form-check-label">R</label>
                      </div>

                      <div className="d-flex ms-2">
                        <input
                          type="checkbox"
                          checked={labodata.xray.lowerExtremities[`${item.toLowerCase()}-l`] || false}
                          onChange={(e) => handleSideCheckbox(
                            'xray',
                            'lowerExtremities',
                            item,
                            'l',
                            e.target.checked
                          )}
                          className="checkbox"
                        />
                        <label className="form-check-label">L</label>
                      </div>
                    </>
                  )}

                  {item === "Toe specify" && (
                    <input
                      type="text"
                      value={labodata.xray.lowerExtremities.toeSpecify}
                      onChange={(e) => handleTextChange(
                        'xray',
                        'lowerExtremities',
                        'toeSpecify',
                        e.target.value
                      )}
                      className="me-2 form-control"
                      style={{ border: 'none', width: '20%', borderBottom: '2px solid #0056B3', borderRadius: '0' }}
                    />
                  )}
                </div>
              ))}
            </div>

            {/* X-RAY Notes */}
            <div className="d-flex align-items-center justify-content-center mt-5">
              <label className="me-3 form-check-label" style={{ fontSize: "14px", whiteSpace: 'nowrap' }}>
                Notes* :
              </label>
              <input
                type="text"
                value={labodata.xray.notes}
                onChange={(e) => handleTextChange('xray', 'notes', null, e.target.value)}
                className="me-2 form-control"
                style={{ border: 'none', width: '100%', borderBottom: '2px solid #0056B3', borderRadius: '0' }}
              />
            </div>
          </section>
          <br />

          {/* Section MAMMOGRAM - Similaire aux autres sections */}
          <section>
            <div className="text-white text-center py-3 mb-4" style={{ background: '#0056B3', borderRadius: '15px' }}>
              <h2 className="text-2xl font-bold">MAMMOGRAM / BONE DENSITOMETRY</h2>
            </div>
            
            <div className="row px-3">
              <div className="col-lg-6 mb-3">
                {[
                  "Diagnostic (clinical information is essential)",
                  "Magnified / additional views",
                  "Screening ages 50 to 74 (PQDCS)",
                  "Screening ages 35 to 49, age 75 and over",
                  "Bone densitometry (including dorsolumbar spine profile)"
                ].map((item, index) => {
                  const itemId = `option-${index}`;
                  return (
                    <div key={itemId} className="d-flex align-items-center mb-2">
                      <input
                        type="checkbox"
                        checked={labodata.mammogram.options[itemId] || false}
                        onChange={(e) => handleCheckboxChange(
                          'mammogram',
                          'options',
                          itemId,
                          e.target.checked
                        )}
                        className="me-2 checkbox"
                      />
                      <label className="me-3 form-check-label" style={{ fontSize: "14px" }}>
                        {item}
                      </label>
                    </div>
                  );
                })}
              </div>
              <div className="col-lg-6 mb-3 text-center">
                <img src={Sein} className='img-fluid w-100' alt="Mammogram illustration" />
                <div className="d-flex align-items-center justify-content-center mt-3">
                  <label htmlFor="last-exam-date" className="me-2" style={{ fontSize: "14px", fontWeight: "800" }}>
                    Date of last examination :
                  </label>
                  <input
                    type="date"
                    id="last-exam-date"
                    value={labodata.mammogram.lastExamDate}
                    onChange={(e) => handleDateChange(e.target.value)}
                    className="date-input"
                    style={{
                      border: "none",
                      fontSize: "14px",
                      color: "#888",
                      outline: "none",
                      backgroundColor: "transparent"
                    }}
                  />
                </div>
              </div>
            </div>

            {/* MAMMOGRAM Notes */}
            <div className="d-flex align-items-center justify-content-center mt-5">
              <label className="me-3 form-check-label" style={{ fontSize: "14px", whiteSpace: 'nowrap' }}>
                Notes* :
              </label>
              <input
                type="text"
                value={labodata.mammogram.notes}
                onChange={(e) => handleTextChange('mammogram', 'notes', null, e.target.value)}
                className="me-2 form-control"
                style={{ border: 'none', width: '100%', borderBottom: '2px solid #0056B3', borderRadius: '0' }}
              />
            </div>
          </section>
          <br />

          {/* Autres sections seraient implémentées de la même manière... */}

          {/* Boutons de sauvegarde */}
          <div className="d-flex justify-content-center gap-4 mt-4">
            <Button 
              variant="secondary" 
              onClick={() => setShowModal(false)}
              className="d-flex align-items-center px-4 py-2 shadow"
              style={{ background: '#1A5D1A' }}
            >
              Go back <img src={Log} className='ms-2' alt="Go back" />
            </Button>
            <Button 
              variant="primary" 
              onClick={handleSave}
              className="d-flex align-items-center px-4 py-2 shadow"
            >
              Save <img src={Log1} className='ms-2' alt="Save" />
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default EditableBlockList;
